<template>
  <div class="PublicTable">
    <!-- 主题el-table一些设置表头可根据情况添加 -->
    <el-table
      :row-style="tableRowStyle"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#f8fbff' }"
      @selection-change="handleSelectionChange"
      :height="tableHeight"
    >
      <!-- 全选单选 -->
      <el-table-column
        v-if="configFlag.selection"
        align="center"
        width="55"
        type="selection"
      />

      <!-- 序号列 -->
      <el-table-column
        v-if="configFlag.index"
        align="center"
        width="100"
        type="index"
        :index="1"
        :label="configFlag.indexName || '序号'"
      />

      <!-- 循环遍历表头展示数据 -->
      <template v-for="item in tableTitleData">
        <el-table-column
          :key="item.label"
          v-if="item.prop&&item.prop !== 'action'"
          :width="item.width || ''"
          :prop="item.prop"
          :label="item.label"
          :align="item.align || 'center'"
          :sortable="item.sortable"
          header-align="center"
        >
        <template slot-scope="scope">
          <!-- 根据需求添加效果 返回的slot可以优化.自己来吧. -->
          <slot v-if="item.slotname"  :name='item.slotname' :data='scope.row'></slot>
          <div v-else>
            <span>{{ scope.row[item.prop] }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          v-else-if="item.prop==='action'"
          :key="item.prop"
          :label="item.label"
          :width="item.width"
          :fixed="!!item.fixed"
          :align="item.align || 'center'"
           header-align="center"
        >
          <template slot-scope="scope">
            <template v-if="item.arr">
              <el-button
                size="mini"
                :disabled="hasPermiFn([item2.hasPermi])"
                :type="item2.type=='delete'?'danger':'text'"
                v-for="(item2,index) in item.arr"
                :key="index"
                @click="item2.fun(scope.$index, scope.row)"
              >{{item2.name}}
              </el-button>
            </template>
          </template>
        </el-table-column>
      </template>

    </el-table>
    <div class="pagination-container">
    <el-pagination
        v-if="configFlag.needPage"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="pageValue.pageNum"
        :page-size="pageValue.pageSize"
        :page-sizes="customPageSizesOptions"
        :total="pageValue.total">
    </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      selectRow:[],
      multipleSelection:[]
    }
  },
  props: {
    tableTitleData: {
      // 表头数据  文案和绑定值，以及需要特殊处理的slot
      type: Array,
      default: () => []
    },

    tableData: {
      type: Array, // 后台数据
      default: () => []
    },
    pageSizes:{
      type: Array, // 后台数据
      default: () => {
        return [10,15,20]
      }
    },
    pageValue: {
      // 分页数据
      type: Object,
      default: () => {
        return {
          pageNum: 1,
          pageSize: 10,
          total: 0
        };
      }
    },

    configFlag: {
      // 配置  其他table配置依次添加
      type: Object,
      default: () => {
        return {
          needPage: false, // 是否需要排序
          selection: false, // 是否需要多选
          index: false // 是否需要序号
          // 这里不全面，可根据实际情况添加
        };
      }
    },
    tableHeight: {
      // 可以监听屏幕高度获取。
      // 高度
      type: Number|String,
      default: () => {
        return 'calc(100vh - 400px)'
      }
    }
  },
  watch:{
    // 监听选中状态
    multipleSelection(data) {
      this.selectRow = []
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.selectRow.push(item.id)
        })
      }
    }
  },
  methods: {
    tableRowStyle({row, rowIndex}) {
      if (this.selectRow.includes(row.id)) {
        return { 'background-color': '#e6f7ff' }
      }
    },
    // 翻页
    sizeChange(val) {
      console.log('sizeChange val: ', val);
      this.$emit("handleChange", { pageSize: val });
    },

    // 设置条数
    currentChange(val) {
      console.log('currentChange val: ', val);
      this.$emit("handleChange", { pageNum: val });
    },

    // 多选
    handleSelectionChange(val) {
      this.multipleSelection=val

      this.$emit("handleSelectionChange", val);
    }
  }
};
</script>
<style scoped>
  .PublicTable /deep/ .el-table__cell {
    padding: 10px 0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/lib/table.vue